import { Component } from '@angular/core';
import { TermsModal } from '../../authentication/services/terms-modal.service';

@Component({
  selector: 'app-layout',
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss'],
})
export class AuthLayoutComponent {
  public openedTerms = false;
  public acceptedTerms = false;
  public buildNumber = '20250318.1740';

  constructor(private termsModalService: TermsModal) {
    // Subscribe to modal state changes
    this.termsModalService.modalState$.subscribe((state) => {
      this.openedTerms = state;
    });
  }

  openTerms() {
    this.openedTerms = true;
    this.acceptedTerms = true;
  }

  acceptTerms() {
    this.termsModalService.acceptTerms();
  }

  // Close terms
  closeTerms() {
    this.termsModalService.closeModal();
    this.acceptedTerms = false;
  }
}
